import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
var TextInputComponent = /*@__PURE__*/ (function () {
    function TextInputComponent() {
        this.placeholder = '';
        this.type = 'text';
        this.disabled = 'false';
        this.initialValue = '';
        this.class = '';
        // The internal data model
        this.innerValue = '';
    }
    TextInputComponent_1 = TextInputComponent;
    TextInputComponent.prototype.onInputChange = function (target) {
        if (target.hasAttribute('maxLength')) {
            if (target.value.length > target.maxLength)
                target.value = target.value.slice(0, target.maxLength);
        }
    };
    Object.defineProperty(TextInputComponent.prototype, "value", {
        // get accessor
        get: function () {
            return this.innerValue;
        },
        // set accessor including call the onchange callback
        set: function (v) {
            if (v !== this.innerValue) {
                this.innerValue = v;
                this.onChangeCallback(v);
            }
        },
        enumerable: true,
        configurable: true
    });
    // Set touched on blur
    TextInputComponent.prototype.onBlur = function () {
        this.onTouchedCallback();
    };
    // From ControlValueAccessor interface
    TextInputComponent.prototype.writeValue = function (value) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    };
    // From ControlValueAccessor interface
    TextInputComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    // From ControlValueAccessor interface
    TextInputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    var TextInputComponent_1;
    return TextInputComponent;
}());
export { TextInputComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/text-input/text-input.component.ts
// module id = null
// module chunks = 